import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'img[appImgErrorHandler]'
})
export class ImgErrorHandlerDirective {

  @Input() fallbackImages: string[] = [];
  @Input() defaultImage: string = '../../../../../../assets/not_found_image.png';

  private currentImageIndex = 0;

  constructor(private el: ElementRef) { }

  @HostListener('error')
  onError() {
    if (this.currentImageIndex < this.fallbackImages.length) {
      // Intenta la siguiente imagen
      this.el.nativeElement.src = this.fallbackImages[this.currentImageIndex];
      this.currentImageIndex++;
    } else {
      // Si ninguna imagen funciona, usa la imagen por defecto
      this.el.nativeElement.src = this.defaultImage;
    }
  }
}
